module.exports = __webpack_public_path__ + "static/media/presentation_1.be80f084.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neonat/icons/presentation_1.svg
// module id = 646
// module chunks = 1